import { get, post } from 'api/request';
import urls from 'configs/urls';

export const getAllLabs = () => get(null, false, urls.labsModuleUrls.commonUrls.getAllLabs);

export const getUsers = ({ query, data }) => {
  let url = urls.labsModuleUrls.commonUrls.getUsers;
  if (query) url = `${urls.labsModuleUrls.commonUrls.getUsers}?${query}`;

  return get(null, false, url, data);
};

export const getLabsCatalog = ({ query, headers }) => {
  const url = `${urls.labsModuleUrls.commonUrls.getLabsCatalog}?${query}`;

  return get(headers, false, url, null);
};

export const searchLabsCatalog = ({ data, headers }) =>
  get(headers, false, urls.labsModuleUrls.commonUrls.searchLabsCatalog, data);

export const getUploadedContent = ({ orderId }) =>
  get(null, false, `${urls.labsModuleUrls.commonUrls.uploadContent}/${orderId}`);

export const uploadContent = ({ data }) =>
  post(null, false, urls.labsModuleUrls.commonUrls.uploadContent, data);
